/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Add from '@material-ui/icons/Add';

import classList from '../utils/classList';
import { rowSpacing } from '../style/variables';
import AnimatedCheck from '../assets/svg/AnimatedCheck';

const styles = ({ palette }) => ({
    card: {
        minWidth: 275,
        position: 'relative',
    },

    cardContent: {
        position: 'relative',
        color: `${palette.cta1}`,
        padding: `${rowSpacing}px !important`,
        display: 'flex',
        'align-items': 'center',
    },

    recipientName: { flex: 1 },
});

class CardLayout extends Component {
    populateRecipientName = (classes, recipient) => {
        if (recipient.type !== 'button') {
            return (
                <>
                    {recipient.addToCart ? (
                        <AnimatedCheck className="success-color margin-right-half" />
                    ) : (
                        ''
                    )}
                    <h2
                        className={classList(
                            'no-margin',
                            `${classes.recipientName}`,
                        )}
                    >
                        {recipient.firstname} {recipient.lastname}
                    </h2>
                    <ChevronRight />
                </>
            );
        }
        return (
            <>
                <Add className="margin-right-half" />
                <h2
                    className={classList(
                        'no-margin',
                        `${classes.recipientName}`,
                    )}
                >
                    {recipient.name}
                </h2>
            </>
        );
    };

    render() {
        const {
            classes, customClass, recipient, onClick,
        } = this.props;
        return (
            <Card key={recipient.id} className={`${classes.card} ${customClass}`}>
                <CardContent
                    className={`${classes.cardContent} modal-card-content`}
                    onClick={() => onClick(recipient)}
                >
                    {this.populateRecipientName(classes, recipient)}
                </CardContent>
            </Card>
        );
    }
}

CardLayout.defaultProps = {
    customClass: '',
};

CardLayout.propTypes = {
    classes: PropTypes.object.isRequired,
    customClass: PropTypes.string,
    recipient: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(CardLayout);
